import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// models
import {
  EmissionDocument,
  MenuDownloadProps,
} from 'src/models/emission/EmissionDocument';
import { RequestIndicatorTypes } from 'data-layer-cr/dist/models';

export type PolicycState = {
  fileData: EmissionDocument;
  currentFileDownload: string;
  downloadStatus: RequestIndicatorTypes;
  isError: boolean;
  errorDetail: string;
  menuDownloadOptions: MenuDownloadProps;
  menuDownloadStarted: boolean;
  showDownloadMenuStatus: boolean;
};

export const initialState: PolicycState = {
  fileData: {
    name: '',
    content: '',
    mime: '',
  },
  currentFileDownload: '',
  downloadStatus: 'initial',
  isError: false,
  errorDetail: '',
  menuDownloadOptions: {
    hasIdentityDocument: false,
    hasOptionalIdentityDocument: false,
    quotationHash: '',
    startDownload: false,
    inspectionRequired: false,
    createdAt: '',
  },
  showDownloadMenuStatus: false,
  menuDownloadStarted: false,
};

const policySlice = createSlice({
  name: 'policy',
  initialState,
  reducers: {
    updateFileData: (state, action: PayloadAction<EmissionDocument>) => {
      state.fileData = action.payload;
    },
    updateCurrentFileDownload: (state, action: PayloadAction<string>) => {
      state.currentFileDownload = action.payload;
    },
    updateDownloadStatus: (
      state,
      action: PayloadAction<RequestIndicatorTypes>,
    ) => {
      state.downloadStatus = action.payload;
    },
    updateIsErrorDownload: (state, action: PayloadAction<boolean>) => {
      state.isError = action.payload;
    },
    updateMenuDownloadStarted: (state, action: PayloadAction<boolean>) => {
      state.menuDownloadStarted = action.payload;
    },
    updateErrorDetail: (state, action: PayloadAction<string>) => {
      state.errorDetail = action.payload;
    },
    updateMenuDownloadOptions: (
      state,
      action: PayloadAction<MenuDownloadProps>,
    ) => {
      state.menuDownloadOptions = action.payload;
    },
    updateShowDownloadMenuStatus: (state, action: PayloadAction<boolean>) => {
      state.showDownloadMenuStatus = action.payload;
    },
  },
});

export const {
  updateFileData,
  updateCurrentFileDownload,
  updateDownloadStatus,
  updateErrorDetail,
  updateIsErrorDownload,
  updateMenuDownloadOptions,
  updateShowDownloadMenuStatus,
  updateMenuDownloadStarted,
} = policySlice.actions;

export default policySlice.reducer;
